import React, { useRef } from 'react';
import { loadFileFromReader } from '../services/fileService';

type MediaPickerProps = {
  mediaType?: 'image' | 'video';
  onAttached: (...args: any[]) => void;
  onError: (...args: any[]) => void;
  attachMultiple?: boolean;
  useCamera?: boolean;
  children?: any;
};

const fileMorpher = async (data: any) => {
  try {
    const dataUrl = await loadFileFromReader(data);

    return {
      base64: dataUrl,
      name: data.name,
      size: data.size,
      type: data.type,
    };
  } catch (err) {
    console.error(err);
    return err;
  }
};

const morphDataByType = async (data: unknown) => {
  const fileMorphedData = await fileMorpher(data);
  return fileMorphedData;
};

export default function MediaPicker(props: MediaPickerProps) {
  const { onAttached, onError, children, useCamera } = props;

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleAttachment = async (event: { target: { files: any } }) => {
    const { files } = event.target;
    files.length = undefined;

    const filesArray = Object.values(files);
    try {
      const morphedFileData = await Promise.all(
        filesArray.map((file) => morphDataByType(file)),
      );
      onAttached(morphedFileData);
      if (inputRef?.current) {
        inputRef.current.value = '';
      }
    } catch (e) {
      onError(e);
    }
  };

  // TODO: Significantly refactor
  return (
    <>
      <input
        style={{ display: 'none' }}
        type='file'
        accept={
          useCamera
            ? 'image/*;application/pdf;capture=camera'
            : 'image/*;application/pdf'
        }
        onChange={handleAttachment}
        multiple={false}
        ref={inputRef}
      />
      {children &&
        React.cloneElement(children, {
          onClick: () => {
            if (inputRef?.current) {
              inputRef.current.click();
            }
          },
        })}
    </>
  );
}
